module.exports = __webpack_public_path__ + "img/only1-generation-home.c3b2890e.webp";